import _ from 'lodash'
import { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { getBodyType } from '../../../../../common/services/common.service';
import { IoInformationCircleOutline } from 'react-icons/io5';
import InfoPopup from '../../../../../common/components/InfoPopup';


export default function VehicleCard({ loadCapacity, isButtonLoading, vehicleData, productTypeCargo, handleEstimate, selectedEstimateItem, handleInnerFormChange }: any) {

    const [vehicle, setVehicle] = useState<any>();
    const [selectVehicleData, setSelectVehicleData] = useState<any>([]);
    const [infoOpen, setInfoOpen]: any = useState(false)

    const dummyImage = require('../../../../../assets/img/image.png')
    const onEstimateClick = () => {
        handleEstimate(vehicle)
    }
    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;

        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);
    useEffect(() => {

        if (selectedEstimateItem?.vehicleCategoryId) {
            const CapacityData: any = _.filter(vehicleData, ['LogisticsVehicleCategoryId', Number(selectedEstimateItem?.vehicleCategoryId)]);
            setSelectVehicleData(CapacityData)
        }
    }, [selectedEstimateItem]);

    useEffect(() => {
        if (!selectedEstimateItem?.CategoryId && loadCapacity?.length > 0) {
            handleInnerFormChange(loadCapacity[0].Id, 'vehicleCategoryId');
        }
    }, [loadCapacity]);


    return (
        <>
            <InfoPopup data={vehicle} open={infoOpen} setOpen={setInfoOpen} />
            <div className="max-w-3xl mx-auto mt-6 p-4 sm:p-6 rounded-2xl shadow-md bg-white">
                <h2 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800">
                    Estimate Vehicle Category Type
                </h2>

                {/* Vehicle Loading Capacity */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Vehicle Loading Capacity:
                    </label>
                    <div className="flex flex-wrap gap-2">
                        {loadCapacity?.map((item, index) => {
                            const isActive = selectedEstimateItem?.vehicleCategoryId === item.Id;
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    onClick={() => handleInnerFormChange(item.Id, "vehicleCategoryId")}
                                    aria-pressed={isActive}
                                    className={`text-sm px-3 py-1 rounded-md border transition-colors
              ${isActive
                                            ? "border-blue-500 bg-blue-50 text-blue-600 font-semibold"
                                            : "border-gray-200 text-gray-700 hover:border-blue-300 hover:text-blue-500"
                                        }`}
                                >
                                    {item.LogisticsVehicleCategoryName}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Vehicle Selection */}
                {selectVehicleData && selectedEstimateItem?.vehicleCategoryId ? (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                        {selectVehicleData?.map((item: any, index: any) => (
                            <button
                                key={index}
                                onClick={() => setVehicle(item)}
                                className={`w-full relative flex flex-col items-center justify-center p-3 rounded-xl transition 
            ${vehicle == item
                                        ? "border-2 border-blue-500 bg-blue-50"
                                        : "border border-gray-200 bg-gray-50 hover:border-blue-300"
                                    }`}
                            >
                                {/* Info Icon */}
                                <div
                                    onClick={() => setInfoOpen(!infoOpen)}
                                    className="absolute top-2 right-2 text-gray-400 hover:text-blue-500"
                                >
                                    <IoInformationCircleOutline className="w-4 h-4" />
                                </div>

                                <div className="flex items-center justify-center w-full my-2">
                                    {item?.MediaMappings?.MediaFiles?.length > 0 ? (
                                        <img
                                            src={item.MediaMappings.MediaFiles[0].FileMappingURL}
                                            alt={item.LogisticsVehicleCategoryName}
                                            className="w-16 h-16 object-contain"
                                        />
                                    ) : (
                                        <img
                                            src={dummyImage}
                                            alt=""
                                            className="w-16 h-16 object-contain"
                                        />
                                    )}
                                </div>
                                <div className="text-sm font-medium">{item?.VehicleName}</div>
                                <div className="text-xs text-gray-500">
                                    {getBodyType(item?.VehicleBodyTypeId)}
                                </div>
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="text-sm text-gray-500">
                        {selectVehicleData && selectedEstimateItem?.CategoryId
                            ? "No vehicle available for this category."
                            : "Please select a category."}
                    </div>
                )}

                {/* Divider */}
                <div className="border-t my-6"></div>

                {/* Selected Details + Form */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="text-sm text-gray-600">Selected:</div>
                    <div className="text-sm font-semibold text-gray-800">
                        {vehicle?.VehicleName || "None"}
                    </div>

                    <div className="text-sm text-gray-600">Trip Base Price:</div>
                    <div className="text-sm font-semibold text-gray-800">
                        ₹ {vehicle?.TripVehicleBasePrice || "0"}
                    </div>

                    <div className="text-sm text-gray-600">Loading Capacity:</div>
                    <div className="text-sm font-semibold text-gray-800">
                        {`${vehicle?.LoadingCapacity || 0} Kg`}
                    </div>

                    <div className="text-sm text-gray-600">Vehicle Dimension (LxWxH):</div>
                    <div className="text-sm font-semibold text-gray-800">
                        {vehicle?.VehicleDimension?.length?.value || 0}x
                        {vehicle?.VehicleDimension?.breadth?.value || 0}x
                        {vehicle?.VehicleDimension?.height?.value || 0} ft
                    </div>

                    {/* Product Type */}
                    <div className="text-sm text-gray-600">Product Type:</div>
                    <div>
                        <select
                            required
                            className="border border-gray-300 rounded-md w-full px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e) => handleInnerFormChange(e.target.value, "CategoryId")}
                            value={selectedEstimateItem?.CategoryId || ""}
                        >
                            <option value="">--select--</option>
                            {productTypeCargo?.map((item, index) => (
                                <option value={item.Id} key={index}>
                                    {item.Name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Product Price */}
                    <div className="text-sm text-gray-600">Approx. Product Price:</div>
                    <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                            ₹
                        </span>
                        <input
                            type="number"
                            onChange={(e) => handleInnerFormChange(e.target.value, "ProductValue")}
                            value={selectedEstimateItem?.ProductValue}
                            placeholder="Enter amount"
                            className="pl-7 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* Date & Time */}
                    <div className="text-sm text-gray-600">Schedule Date & Time:</div>
                    <input
                        id="datetime"
                        type="datetime-local"
                        name="scheduleDate"
                        min={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                            .toISOString()
                            .slice(0, 16)}
                        className="w-full border rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onClick={(event) => {
                            const input = event.target as HTMLInputElement;
                            input.showPicker();
                        }}
                        onChange={(e) => handleInnerFormChange(e.target.value, "date")}
                        value={selectedEstimateItem?.date}
                    />
                </div>

                {/* Estimate Button */}
                <div className="mt-6 flex justify-center">
                    <button
                        onClick={onEstimateClick}
                        disabled={isButtonLoading}
                        className={`flex items-center justify-center px-4 py-2 text-sm font-bold rounded-md text-white ${isButtonLoading
                            ? "bg-blue-500 bg-opacity-70"
                            : "bg-blue-600 hover:bg-blue-700"
                            }`}
                    >
                        Estimate
                        {isButtonLoading && (
                            <div className="pl-2">
                                <RotatingLines
                                    visible={true}
                                    width="16"
                                    strokeColor="#fff"
                                    strokeWidth="5"
                                    animationDuration="0.75"
                                />
                            </div>
                        )}
                    </button>
                </div>
            </div>
        </>




    );
}
